module.exports = __webpack_public_path__ + "static/media/Lease.873f48e5.svg";